export const environment = {
  instance: "qa",
  production: false, 
  showLogs: true,
  region: 'ap-southeast-1', 
  bucketName: 'bbb-qa-storage',
  cognitoUserPoolId: 'ap-southeast-1_jDnQOVEz5', 
  cognitoAppClientId: '671kbk7258qopf37ppnjljgi2m', 
  cognitoIdentityEndpoint: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_jDnQOVEz5', 
  cognitoIdentityPoolId: 'ap-southeast-1:eaf3dffc-7a99-469c-8c4d-48e50880f9da',
  apiEndpoint: 'https://300cpvsnti.execute-api.ap-southeast-1.amazonaws.com/qa/',  
  showFaqFirst: true,
  allowLogin: true,
  consolidatorFaqUrl: "https://imsbbbconsolqa.eschost2.com/frequently-asked-questions",
  deconsolidatorFaqUrl: "https://imsbbbdeconsolqa.eschost2.com/frequently-asked-questions",
  ofwFaqUrl: "https://imsbbbqa.eschost2.com/frequently-asked-questions",
  auth: {
    identityPoolId: 'ap-southeast-1:eaf3dffc-7a99-469c-8c4d-48e50880f9da',
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_jDnQOVEz5',
    userPoolWebClientId: '671kbk7258qopf37ppnjljgi2m',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH'
  },
  api: {
    endpoints: [
      {
        name: "DeconsolidatorAPIs",
        endpoint: "https://300cpvsnti.execute-api.ap-southeast-1.amazonaws.com"
      }
    ]
  }
};